<template>
  <ab-modal
    :title="modalTitle ? modalTitle : `搜索结果：“${keywords}”`"
    :errorMsgStatus="errorMsgStatus"
    :visible="visible"
    :loading="loading"
    :confirm-loading="confirmLoading"
    footer=" "
    @cancel="handleCancel"
  >
    <div v-if="loading" style="height: calc(100vh - 200px);">
      <a-spin
        style="width: 100%; height: 100%; align-items: center; display: flex; justify-content: center;"
      >
      </a-spin>
    </div>
    <div
      v-else
      class="intelligent-row det-intelligent-row"
      style="min-height: calc(100vh - 200px);"
    >
      <a-list :data-source="sourceData">
        <a-list-item slot="renderItem" slot-scope="item, index">
          <a-list-item-meta>
            <a slot="title">
              <!-- <div class="title">
                {{ item.title }} <em>在售</em>
                <div class="det-time">检测时间：{{ item.time }}</div>
              </div>
              <div class="logo_pic">{{ item.logo }}</div>
              <div class="set">
                <i class="iconfont icon-31dingwei"></i> {{ item.set }}
              </div> -->
              <div class="title">
                {{ item.companyName }} <em>在售</em>
                <div v-show="relationData[item.id]" class="det-time">
                  检测时间：{{ checkDate }}
                </div>
              </div>
              <div class="logo_pic">
                {{
                  item.companyName ? item.companyName.substring(0, 1) : '暂无'
                }}
              </div>
              <div class="set">
                <i class="iconfont icon-31dingwei"></i> *********
              </div>
              <div v-show="!relationData[item.id]" class="time">
                <span>注册时间： ********* </span>
                <span>联系电话： ********* </span>
              </div>
              <div v-show="!relationData[item.id]" class="website">
                <span>公司官网：********* </span>
              </div>
              <div v-show="!relationData[item.id]" class="address">
                <span>公司地址： ********* </span>
              </div>
              <div v-show="relationData[item.id]" class="content">
                The information you are inquiring is the real global enterprise
                data. This is only a template instead of display. For detailed
                data, please log in to your account to check. If you do not have
                an exclusive account, you can register for free experience now,
                and you will also receive points...
              </div>
            </a>
          </a-list-item-meta>
          <div v-show="!relationData[item.id]" class="btn_details">
            <a-button type="primary" @click="showRelationContent(item, index)">
              查看详情
            </a-button>
          </div>
          <div v-show="relationData[item.id]" class="det-intelligent-content">
            <div class="det-titlte fontsize20"><em></em> 企业信息</div>
            <table>
              <tr>
                <th>企业名称</th>
                <td>
                  {{
                    relationData[item.id]
                      ? relationData[item.id]['companyName']
                      : ''
                  }}
                </td>
                <th>注册时间</th>
                <td>
                  <!-- {{
                    relationData[item.id]
                      ? moment(relationData[item.id]['createDate']).format(
                          'YYYY-MM-DD'
                        )
                      : ''
                  }} -->
                  *********
                </td>
              </tr>
              <tr>
                <th>本地名称</th>
                <td>*********</td>
                <th>行业编码</th>
                <td>*********</td>
              </tr>
              <tr>
                <th>公司网址</th>
                <td>*********</td>
                <th>公司类型</th>
                <td>*********</td>
              </tr>
              <tr>
                <th>联系电话</th>
                <td>*********</td>
                <th>营业收入</th>
                <td>*********</td>
              </tr>
              <tr>
                <th>传 真</th>
                <td>*********</td>
                <th>员工人数</th>
                <td>*********</td>
              </tr>
              <tr>
                <th>联系邮箱</th>
                <td>*********</td>
                <th rowspan="2">公司地址</th>
                <td rowspan="2">***************************</td>
              </tr>
              <tr>
                <th>公司网址</th>
                <td>************************************</td>
              </tr>
            </table>

            <div class="det-titlte fontsize20"><em></em> 精准联系人</div>
            <a-row :gutter="[20, 20]" class="det-intelligent-ul">
              <a-col :xs="12" :xl="5">
                <div class="det-intelligent-li">
                  <img src="~@/assets/product/head_1.png" alt="" />
                  <p>Dla**********</p>
                  <p>西班牙</p>
                  <p>CEO</p>
                  <p>j**********@********</p>
                  <p>jfedfkd*****</p>
                </div>
              </a-col>
              <a-col :xs="12" :xl="5">
                <div class="det-intelligent-li">
                  <img src="~@/assets/product/head_2.png" alt="" />
                  <p>Dla**********</p>
                  <p>西班牙</p>
                  <p>CEO</p>
                  <p>j**********@********</p>
                  <p>jfedfkd*****</p>
                </div>
              </a-col>
              <a-col :xs="12" :xl="5">
                <div class="det-intelligent-li">
                  <img src="~@/assets/product/head_3.png" alt="" />
                  <p>Dla**********</p>
                  <p>西班牙</p>
                  <p>CEO</p>
                  <p>j**********@********</p>
                  <p>jfedfkd*****</p>
                </div>
              </a-col>
              <a-col :xs="12" :xl="5">
                <div class="det-intelligent-li">
                  <img src="~@/assets/product/head_4.png" alt="" />
                  <p>Dla**********</p>
                  <p>西班牙</p>
                  <p>CEO</p>
                  <p>j**********@********</p>
                  <p>jfedfkd*****</p>
                </div>
              </a-col>
              <a-col :xs="12" :xl="5">
                <div class="det-intelligent-li">
                  <img src="~@/assets/product/head_5.png" alt="" />
                  <p>Dla**********</p>
                  <p>西班牙</p>
                  <p>CEO</p>
                  <p>j**********@********</p>
                  <p>jfedfkd*****</p>
                </div>
              </a-col>
              <a-col :xs="12" :xl="5">
                <div class="det-intelligent-li">
                  <img src="~@/assets/product/head_1.png" alt="" />
                  <p>Dla**********</p>
                  <p>西班牙</p>
                  <p>CEO</p>
                  <p>j**********@********</p>
                  <p>jfedfkd*****</p>
                </div>
              </a-col>
              <a-col :xs="12" :xl="5">
                <div class="det-intelligent-li">
                  <img src="~@/assets/product/head_2.png" alt="" />
                  <p>Dla**********</p>
                  <p>西班牙</p>
                  <p>CEO</p>
                  <p>j**********@********</p>
                  <p>jfedfkd*****</p>
                </div>
              </a-col>
              <a-col :xs="12" :xl="5">
                <div class="det-intelligent-li">
                  <img src="~@/assets/product/head_3.png" alt="" />
                  <p>Dla**********</p>
                  <p>西班牙</p>
                  <p>CEO</p>
                  <p>j**********@********</p>
                  <p>jfedfkd*****</p>
                </div>
              </a-col>
            </a-row>
            <div class="modal-login modal-login-absolute">
              <ab-modal-login-btn-vue>
                <span slot="action-title"
                  >企业认证通过赠送2000积分，每日登录另赠100积分</span
                >
              </ab-modal-login-btn-vue>
            </div>
            <div class="map_bottom"></div>
          </div>
        </a-list-item>
      </a-list>
    </div>
  </ab-modal>
</template>

<script>
import moment from 'moment';
import { enterpriseWebSearch } from '@/api/app-crm.js';
import AbModal from '@/components/AbModal.vue';
import AbModalLoginBtnVue from '@/components/AbModalLoginBtn.vue';
import getUniqueCode from '@/utils/uuid';
export default {
  props: ['visible', 'keywords', 'type'],
  components: {
    AbModal,
    AbModalLoginBtnVue,
  },
  data() {
    return {
      errorMsgStatus: false,
      modalTitle: '',
      confirmLoading: false,
      loading: false,
      moment,
      relationData: {},
      // relationIndex: '0',
      checkDate: moment().format('YYYY-MM-DD'),
      // form: this.$form.createForm(this, { name: 'dynamic_rule' }),
      sourceData: [],
      pagination: {
        current: 1,
        pageSize: 5,
        total: 0,
        // showTotal: 'total => ``',
        showTotal: (total) => `共计${total}条`,
      },
    };
  },

  mounted() {
    // console.log(this.record, '------this.record------');
  },

  watch: {
    // watch 监听 props 中的值
    keywords(newVal, oldVal) {
      if (newVal) {
        this.initData();
        this.fetchData({
          keyword: newVal,
          type: this.type,
        });
      }
    },
  },

  methods: {
    initData() {
      this.sourceData = [];
      this.relationData = {};
      const pagination = { ...this.pagination, current: 1, total: 0 };
      // pagination.current = 1;
      this.pagination = pagination;
    },
    handleCancel(e) {
      // this.visible = false;
      this.$emit('cancel');
    },

    async fetchData(params) {
      this.loading = true;
      const uuid = await getUniqueCode();
      let param = {
        ...params,
        uuid,
        current: this.pagination.current,
      };
      enterpriseWebSearch(param).then((data) => {
        if (data.code === 3007001) {
          this.errorMsgStatus = true;
          this.modalTitle = '搜索提示';
          return;
        }

        let sourceData = data.data.list ? data.data.list : [];
        const pagination = { ...this.pagination };

        // pagination.total = 500;
        pagination.total = data.data.pages.totalCount || 0;
        this.sourceData = sourceData;
        this.pagination = pagination;
        this.loading = false;
      });
    },

    showRelationContent(item, index) {
      // this.relationIndex = item.id;
      this.relationData = {
        [item.id]: item,
      };
    },
  },
};
</script>

<style lang="sass" scoped>
.det-intelligent-row.intelligent-row{

  ::v-deep .ant-empty{
    // min-height: calc(100vh - 200px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .modal-login-absolute{
    position: relative;
    z-index: 2;margin-bottom:40px;
  }
  .det-intelligent-content{
        padding-top: 40px;
    .map_bottom {
    background: linear-gradient(to top,rgb(255,255,255,1),transparent);
    height: 700px;
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0px;
    index: 1;
}
    .det-intelligent-ul{
      padding-bottom:20px;
      .det-intelligent-li{
        height:325px;
        img{
          width:100px;
          height:100px;
         border-radius: 50%;
         margin:30px 0px;
        }
        p{
          margin-bottom:10px;
        }
       background: #FFFFFF;
      border-radius: 6px;
      border: 1px solid #DCE6FF;
      color: #333646;
      font-size:14px;
      text-align:center;
      }
      .ant-col-xl-5{
        width: 20%;
      }
    }
    table{
      width: 100%;border-collapse: collapse;
      margin-bottom:60px;
      background:#fff;
      td,th{
        font-weight:400;
        border: solid #DCE6FF 1px;
        text-align:center;
        font-size:18px;
        color: #333646;
        line-height:54px
      }

      td{
        text-align:left;
        color:#666;
            text-indent: 30px;
      }
    }
    .det-titlte{
      color: #2B68FF;
      margin-bottom:15px;
      em{
       width: 4px;
       display: inline-block;
       margin-right:8px;
       position: relative;
       top: 3px;
        height: 20px;
        background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
      }
    }

  }

  a{
    cursor: default;
  }
  .content{
    color:#333646;
    font-size:18px;
  }
  .ant-list-split .ant-list-item:hover{
 box-shadow: 0 0.21333rem 0.42667rem 0 rgb(43 104 255 / 30%);
    border-color: #198BFF;
    background: #fff;
  }
  .det-time{
    position: absolute;
    color:#FF6531;
    right: 0px;
    top: 9px;
  }
}
.intelligent-row{
  padding:20px 80px;
    color: #333646;
    font-size:12px;
    .ant-list-item-meta-title{
      margin-bottom:0px;

    }
  .time,.website,.address{
    padding:2px 0px;
  color: #333646;
  }
  .time span{
    padding-right:40px
  }
  .address{
    padding-bottom:0px;
  }
  .set{
        margin-bottom: 12px;
    font-size:12px;
    color: #2B68FF;
    margin-top:5px;
    i{
          position: relative;
    top: 2px;
    }
  }
  .logo_pic{
    width: 150px;
    height: 150px;
    background: rgba(43,104,255,.3);
    border-radius: 8px;
    color: #fff;
    font-size: 131px;
    text-align: center;
    line-height: 4rem;
    font-weight: bold;
    position: absolute;
    top: 0px;
    left:0px

  }
  .ant-list-item-meta-title{
    a:hover .title{
       color: #2B68FF;
    }
    a{

    padding-left: 180px;
    position: relative;
    display: inline-block;
      .title{

        em{
          width: 36px;
          height: 18px;
          font-size:12px;
          display: inline-block;
          color:#fff;
          background: #24FFB6;
          line-height: normal;
          text-align: center;
          margin-left: 10px;
          }
        font-size: 20px;
        color: #333646;
        line-height: 27px;
        padding-top:5px;
      }
    }

  }
  .btn_details{
    button{
      width:200px;
      height:64px;
      font-size:22px;
      font-family: Alibaba-PuHuiTi;
      background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
      border-radius:8px;
      &:hover{
        background: linear-gradient(230deg, #0976e4 0%, #0976e4 100%);
      }
    }
  }
  .ant-list-split .ant-list-item:nth-child(2n){
    .logo_pic{
      background-color:rgba(255,101,49,0.3)
    }
  }
  .ant-list-split .ant-list-item:nth-child(3n){
    .logo_pic{
      background-color:rgba(36,255,182,0.3)
    }
  }
   .ant-list-split .ant-list-item:nth-child(4n){
    .logo_pic{
      background-color:rgba(225,37,27,0.3)
    }
  }
  .ant-list-split .ant-list-item{
    overflow: hidden;
      &:hover{
        box-shadow: 0 0.21333rem 0.42667rem 0 rgb(43 104 255 / 30%);
        border-color: #198BFF;
        background:#fff;
      }
   border: 1px solid #DCE6FF;
   padding:25px 60px;
   background: #F9FBFF;
    border-radius: 8px;
    margin:16px 0px;
    position: relative;
    display:block;
    .btn_details{
          position: absolute;
    right: 60px;
    top: 68px;
    }

  }

}
.ab-item{
  width: 100%;
  .item-content{
    display: flex;
    align-items: center;
    .desc{
      width: 90%;
      white-space:normal;
      word-break:break-all;
      word-wrap:break-word;
      height: 75px;
      font-family: Alibaba-PuHuiTi-R;
      color: #333646;
      line-height: 25px
    }
  }
}
</style>
